export default __webpack_public_path__ + "static/media/chartres10.a6c68df2.jpg";